// hooks/usePredictionFlow.js
// Update the usePredictionFlow.js hook to properly handle the paidWithStarCoins flag

import { useState } from 'react';

export const usePredictionFlow = () => {
  const [predictionState, setPredictionState] = useState({
    showModal: false,
    isRunning: false,
    step: 0,
    showSportSelector: false,
    selectedSport: null,
    results: null,
    paidWithStarCoins: false // Add this flag to track payment method
  });

  const updatePredictionState = (updates) => {
    setPredictionState(prev => ({
      ...prev,
      ...updates
    }));
  };

  return {
    predictionState,
    updatePredictionState
  };
};